module.exports = __webpack_public_path__ + "images/interview-Deloitte-2.svg";